import React from 'react';
import styles from '../TripTrackingV2.module.scss';

const formatTat = (tat) => {
  const days = parseInt(tat, 10);
  if (!days && days !== 0) return null;
  return `${days} day${days === 1 ? '' : 's'}`;
};

const TotalDistanceCard = ({ distance, tat }) => {
  const tatLabel = formatTat(tat);
  return (
    <section className={styles.card}>
      <div className={styles.locationName}>{`Total Distance: ${parseInt(distance, 10) || 0} km`}</div>
      {tatLabel && <div className={styles.locationName}>{`TAT: ${tatLabel}`}</div>}
    </section>
  );
};

export default TotalDistanceCard;
